import { getThemeData } from 'theme-utilities';

export const subscribeToMailingList = async (listID, emailAddress, trackingPermission, recipientData) => {
	const themeData = await getThemeData();

	const formData = new FormData();

	formData.append('action', 'inxmail_subscribe');
	formData.append('inxmail_recipient', emailAddress);
	formData.append('inxmail_mailing_list', listID);
	formData.append('inxmail_recipient_tracking', trackingPermission);

	for (const [key, value] of Object.entries(recipientData)) {
		formData.append(`inxmail_recipient_data[${key}]`, value);
	}

	// Send API request.
	const result = await fetch(themeData.ajax_route, {
		method: 'POST',
		body: formData,
	});
	const json = await result.json();
	return json;
};
